
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coverage",
      function () {
        return require("private-next-pages/coverage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coverage"])
      });
    }
  